import { put, call, takeEvery, select } from 'redux-saga/effects';

import { formatError } from '../../../libs';
import productAPI from '../../api/product';
import { Types, Creators as RecommendationsCreators } from '../../reducers/recommendations';
import getState from '../../utils/getState';
import getToken from '../../utils/getToken';

function* getProductsPaginated({ recommendationData }) {
  try {
    const { app } = yield select(getState);
    const siteId = app.getIn(['config', 'siteId']);
    const token = yield select(getToken);

    const { recommendation, productsId } = recommendationData;

    const id = productsId.join(',');

    const data = yield call(productAPI.recommendations, { id }, siteId, token);

    const loadedProducts = [];

    for (let index = 0; index < productsId.length; index++) {
      const finded = data.find((elm) => elm.id === productsId[index]);

      if (finded) {
        loadedProducts.push({ ...finded, loaded: true });
      } else {
        loadedProducts.push({ id: productsId[index], loaded: true, notFound: true });
      }
    }

    yield put(
      RecommendationsCreators.getProductsPaginatedSuccess({
        recommendation,
        products: loadedProducts,
      })
    );
  } catch (error) {
    yield put(RecommendationsCreators.getProductsPaginatedError(formatError(error)));
  }
}

export default function* watch() {
  yield takeEvery(Types.GET_PRODUCTS_PAGINATED_REQUEST, getProductsPaginated);
}
